import { toUsageRoute } from "./route-templates"

interface RouteMatchLike {
  route: { path?: string }
}

/** Joins the matched route patterns, so ids and tokens in the URL never reach analytics. */
export const routeTemplateFromMatches = (matches: readonly RouteMatchLike[]): string => {
  if (matches.length === 0) return toUsageRoute("")

  const segments = matches.flatMap(match => (match.route.path ?? "").split("/")).filter(Boolean)
  return toUsageRoute(`/${segments.join("/")}`)
}
